'use client'

export const OspreyIllustration = () => {
  return (
    <svg
      data-testid="OspreyIllustration"
      width="300"
      height="229"
      viewBox="0 0 464 354"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M188.426 308.446C249.311 308.446 298.668 259.089 298.668 198.205C298.668 137.32 249.311 87.9628 188.426 87.9628C157.545 87.9628 129.629 100.66 109.615 121.12C99.9973 116.892 89.3655 114.546 78.1857 114.546C35.0049 114.546 0 149.551 0 192.731C0 235.912 35.0049 270.917 78.1857 270.917C86.6243 270.917 94.7507 269.58 102.365 267.107C122.568 292.309 153.613 308.446 188.426 308.446Z"
        fill="url(#paint0_linear_2151_1763)"
      />
      <circle cx="319.877" cy="211.777" r="46.9068" fill="white" stroke="#6FB5BA" strokeWidth="17.21" />
      <path
        d="M266.906 85.1472C271.828 147.492 278.667 209.787 284.889 272.011"
        stroke="#C5CBD7"
        strokeWidth="5.73667"
        strokeLinecap="round"
      />
      <path
        d="M285.67 94.5294C286.393 141.83 285.743 189.41 286.485 236.74C286.715 251.407 287.234 266.621 287.234 281.393"
        stroke="#C5CBD7"
        strokeWidth="1.91222"
        strokeLinecap="round"
      />
      <path
        d="M74.5664 230.573C110.316 230.573 146.071 230.576 181.811 229.661C230.814 228.406 279.7 224.904 328.626 222.103C358.684 220.382 389.232 218.063 419.365 218.063"
        stroke="#C5CBD7"
        strokeWidth="3.82445"
        strokeLinecap="round"
      />
      <rect
        x="82.2746"
        y="123.431"
        width="169.489"
        height="144.469"
        transform="rotate(-7.21912 82.2746 123.431)"
        stroke="white"
        strokeWidth="0.956112"
      />
      <circle cx="275.361" cy="223.731" r="86.0501" stroke="#DFD1B6" strokeWidth="3.82445" />
      <path
        d="M374.018 311.886C352.647 286.606 292.705 239.486 223.902 253.247C137.897 270.447 63.6211 305.631 37.8198 248.555C12.0185 191.48 43.2928 139.096 101.15 133.623C159.008 128.15 145.716 218.845 244.23 203.99C323.041 192.105 418.845 100.003 456.895 55.4368"
        stroke="#051C33"
        strokeWidth="1.91222"
        strokeDasharray="3.82 7.65"
      />
      <path d="M185.606 58.2032L183.873 55.5142L184.351 59.2789L185.606 58.2032Z" fill="#CDBC9D" />
      <path d="M396.654 87.7072L463.894 50.1781L396.654 100.217V87.7072Z" fill="#051C33" />
      <path
        d="M404.652 98.6553L458.45 54.6998L418.102 105.227L404.652 98.6553Z"
        stroke="#051C33"
        strokeWidth="0.956112"
        strokeMiterlimit="16"
      />
      <g style={{ mixBlendMode: 'multiply' }}>
        <path
          d="M318.92 281.907L307.514 284.621L312.578 302.941H314.894L312.578 290.728L318.92 298.87L330.744 296.395L345.758 290.728H336.365L328.313 289.371L318.92 281.907Z"
          fill="#051C33"
        />
        <path
          d="M253.971 80.8292C250.268 86.7123 248.575 174.695 264.658 168.576C280.741 162.458 291.736 144.531 291.736 144.531C306.317 110.589 288.301 91.3618 288.301 87.1596C288.301 81.9069 286.244 79.8058 285.215 73.5025C284.187 67.1993 280.073 70.3509 272.873 69.3003C265.674 68.2498 258.599 73.4754 253.971 80.8292Z"
          fill="#051C33"
        />
        <path
          d="M258.376 112.026C255.471 111.417 254.995 113.684 253.58 114.08L258.286 139.2L265.24 139.423L272.083 122.058L270.913 115.897C268.971 115.404 261.281 112.635 258.376 112.026Z"
          fill="#6FB5BA"
        />
        <path
          d="M257.956 124.65C259.479 107.782 267.154 98.3773 269.85 94.0263C271.119 93.6917 272.856 96.0076 268.423 111.095C264.18 125.538 267.947 138.54 270.326 143.226C266.203 145.234 256.434 141.519 257.956 124.65Z"
          fill="#DFD1B6"
        />
        <path
          d="M268.163 80.2292C272.754 76.9878 279.839 77.6037 283.25 78.0905C292.155 80.2295 282.889 111.194 278.426 109.013C270.988 105.38 266.323 97.3516 264.708 90.9243C263.963 87.958 263.573 83.4706 268.163 80.2292Z"
          fill="#DFD1B6"
        />
        <ellipse
          cx="264.785"
          cy="94.8162"
          rx="3.47699"
          ry="4.47042"
          transform="rotate(-15.6004 264.785 94.8162)"
          fill="#DFD1B6"
        />
        <path
          d="M290.902 83.9366L264.353 86.3498L253.973 80.9141C254.492 78.1139 257.087 71.8217 263.315 69.0545C271.101 65.5954 282.441 67.2135 286.153 72.5135C287.814 74.8854 290.729 80.9717 290.902 83.9366Z"
          fill="#051C33"
        />
        <path
          d="M257.558 83.3391C257.176 78.3673 259.47 73.2999 260.665 71.3877C257.223 78.8454 259.55 86.4465 261.144 89.3148L258.992 91.7051C258.674 90.988 257.941 88.3109 257.558 83.3391Z"
          fill="#D9D9D9"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M239.528 168.144C231.427 179.103 224.427 191.204 224.812 199.507C225.017 221.902 248.721 204.193 256.585 198.318L256.883 198.096V174.992C264.924 177.312 273.09 178.829 278.76 179.428L281.628 176.56C276.791 175.209 267.61 172.093 259.271 168.805L273.686 136.664L281.461 161.979H281.5C282.592 165.849 284.028 168.108 285.198 161.979H287.437L286.628 157.01C290.126 148.441 298.574 139.545 302.974 135.687L307.276 131.384C306.241 131.145 303.691 131.623 298.91 133.535C295.588 134.864 289.801 141.968 285.243 148.504L280.744 120.866L280.703 120.9C277.899 119.174 274.194 117.622 269.926 116.159C268.728 115.748 267.735 120.55 266.712 125.497C264.581 135.803 262.32 146.739 257.798 112.501C256.508 112.146 255.388 111.768 254.359 111.42L254.359 111.42L254.359 111.42C250.582 110.145 248.05 109.29 242.978 111.544C241.341 112.272 240.195 113.261 239.431 114.501L239.393 114.413C239.347 114.541 239.301 114.672 239.254 114.806C238.83 115.577 238.542 116.439 238.366 117.39C235.084 127.194 230.004 145.024 229.832 156.577C229.767 160.991 233.705 164.878 239.528 168.144ZM243.444 161.337C243.594 154.702 242.946 148.619 242.056 143.143C240.345 150.52 239.639 157.984 242.5 160.593C242.757 160.828 243.074 161.076 243.444 161.337Z"
          fill="#6FB5BA"
        />
        <path
          d="M111.75 348.025L95.4363 338.143L86.8906 337.932L87.0106 352.724L93.918 352.805V348.025L102.953 352.805L127.347 353.261L111.75 348.025Z"
          fill="#051C33"
        />
        <path
          d="M156.449 337.392L148.568 321.119L140.356 321.045L132.905 334.079L138.527 337.392L141.037 333.324L148.98 341.489L170.791 342.137L156.449 337.392Z"
          fill="#051C33"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M282.894 228.026L291.345 283.595C292.947 286.52 299.524 291.363 313.018 287.329C326.512 283.295 328.843 276.707 328.321 273.917L292.979 184.662C291.17 179.655 283.853 175.376 278.959 177.861L252.327 176.224C252.327 176.224 225.291 189.946 230.55 208.59C233.541 219.196 252.467 216.706 268.23 212.587L247.663 252.231C247.6 252.598 246.895 253.821 245.862 255.614C241.321 263.496 230.435 282.391 239.777 288.025C251.242 294.942 267.361 295.118 268.394 293.844L282.894 228.026Z"
          fill="url(#paint1_linear_2151_1763)"
        />
        <path
          d="M117.247 188.033C111.183 210.287 102.608 240.748 101.721 263.818C101.347 273.543 100.944 282.351 100.582 290.256C99.2572 319.206 98.4863 336.053 101.721 341.571L83.3056 341.011C83.3056 341.011 58.1097 230.103 88.7048 159.265L88.6403 159.178L88.7624 159.132C88.9615 158.672 89.1632 158.214 89.3675 157.758C121.072 87.0061 130.787 142.465 130.787 142.465C130.61 142.892 130.428 143.333 130.243 143.785L170.072 231.297L157.404 325.078L137.325 323.166L145.93 236.16L117.247 188.033Z"
          fill="url(#paint2_linear_2151_1763)"
        />
        <path
          d="M124.284 55.7543L121.928 58.5153L125.462 75.2939L144.785 73.8072L148.084 64.6745C147.142 63.471 144.597 60.5542 141.958 58.5153C139.318 56.4764 129.076 55.8251 124.284 55.7543Z"
          fill="#A59FD0"
        />
        <circle cx="153.652" cy="25.6812" r="25.6812" fill="#051C33" />
        <path
          d="M154.265 23.2356C161.114 22.2572 168.533 26.9047 171.998 29.3505C180.558 36.6879 153.043 65.4264 149.374 60.5347C143.259 52.382 142.648 40.9681 144.482 33.0191C145.329 29.3505 147.417 24.2139 154.265 23.2356Z"
          fill="#DFD1B6"
        />
        <ellipse cx="142.032" cy="36.0761" rx="4.28021" ry="5.50312" fill="#DFD1B6" />
        <path
          d="M127.971 78.2668C129.927 57.7218 139.792 46.2673 143.257 40.968C144.888 40.5603 146.804 44.1475 141.423 61.7575C136.042 79.3675 140.811 95.1839 143.869 100.891C138.569 103.337 126.014 98.8118 127.971 78.2668Z"
          fill="#DFD1B6"
        />
        <path
          d="M146.927 56.8658C144.97 53.9308 143.665 45.8595 143.258 42.1908C147.538 61.146 155.341 59.0374 154.179 59.757C152.924 60.5339 151.004 61.2157 149.985 61.2157C149.578 61.0119 148.883 59.8008 146.927 56.8658Z"
          fill="#D5C4A3"
        />
        <path d="M138.365 67.872L143.302 43.0253L145.091 48.9168L139.588 68.4835L138.365 67.872Z" fill="#D5C4A3" />
        <path
          d="M118.441 153.613C131.779 151.529 164.213 85.0586 164.213 79.245C164.213 71.9424 152.024 64.3734 143.139 60.3517C142.413 64.7117 144.555 68.1608 138.759 68.0413C129.736 68.2205 129.333 64.7117 132.239 56.9701C117.975 53.6016 103.1 52.5947 97.3592 53.0848C80.8867 77.5107 78.1308 124.594 94.2993 148.355C98.8142 154.99 110.792 154.808 118.441 153.613Z"
          fill="#A59FD0"
        />
        <path
          d="M135.037 147.367L137.052 78.5977L140.075 75.5748L147.127 144.344L140.075 152.657L135.037 147.367Z"
          fill="#051C33"
        />
        <path
          d="M111.896 111.272C105.501 110.691 103.418 114.906 103.176 117.086C111.314 130.456 144.823 143.391 156.45 145.329L158.402 139.613C145.564 130.408 118.29 111.854 111.896 111.272Z"
          fill="#DFD1B6"
        />
        <path
          d="M167.848 146.098C171.336 143.772 166.395 101.045 163.488 79.9714C158.256 74.7395 152.104 85.0581 149.682 90.8714L158.402 139.558C160.097 142.707 164.36 148.423 167.848 146.098Z"
          fill="#A59FD0"
        />
        <path
          d="M163.381 129.673L157.764 138.636L153.342 144.971C153.78 145.488 155.469 146.715 158.72 147.48C161.971 148.245 164.536 147.162 165.413 146.524L170.432 136.724L176.528 126.446L171.986 125.848L163.381 129.673Z"
          fill="#DFD1B6"
        />
        <path d="M165.053 105.091L221.747 100.392L214.467 140.535L158.838 146.098L165.053 105.091Z" fill="#051C33" />
        <path
          d="M156.449 146.285L158.361 139.592L159.317 136.724L153.58 133.856L149.756 144.373L156.449 146.285Z"
          fill="#051C33"
        />
        <path
          d="M207.852 127.204C207.852 122.844 215.845 120.664 218.025 120.664C219.963 119.453 222.523 118.557 221.942 121.464C221.361 124.371 219.478 129.626 218.025 132.291C214.634 132.048 207.852 130.692 207.852 127.204Z"
          fill="#DFD1B6"
        />
        <circle cx="154.536" cy="140.519" r="2.3604" fill="#D9D9D9" />
        <path
          d="M191.824 297.986L198.677 253.049L258.852 250.345L261.341 305.743L191.824 297.986Z"
          fill="#051C33"
          stroke="#051C33"
          strokeWidth="1.91222"
        />
        <path
          d="M209.316 255.442C208.826 251.636 210.13 243.729 219.265 242.553C228.4 241.377 237.08 241.434 240.278 241.609C243.476 241.784 249.975 244.427 250.387 253.597"
          stroke="#051C33"
          strokeWidth="1.91222"
        />
        <path
          d="M137.334 80.2149C134.427 76.5815 129.631 69.7509 133.7 71.4949C135.182 72.1301 136.774 72.399 138.292 72.449C140.942 72.5364 143.368 71.9569 144.6 71.4949C142.275 77.3082 138.787 79.7304 137.334 80.2149Z"
          fill="#051C33"
        />
        <path
          d="M317.589 138.286C316.331 135.454 311.383 132.968 309.066 132.079C302.86 129.632 303.051 132.856 302.881 133.983C302.673 135.357 301.478 136.792 305.272 139.331C310.199 142.63 307.93 139.16 311.776 143.749C314.853 147.421 315.856 147.406 315.972 146.94C317.036 145.235 318.848 141.118 317.589 138.286Z"
          fill="#DFD1B6"
        />
        <path
          d="M308.295 122.432L310.393 121.956L317.013 151.092L316.658 153.554L314.915 151.568L308.295 122.432Z"
          fill="#D9D9D9"
        />
        <path
          d="M312.294 135.328C312.007 134.037 310.979 133.077 310.501 132.758C308.063 131.372 306.896 134.133 306.617 135.686C307.952 137.758 310.896 142.128 311.995 143.037C313.095 143.945 315.043 143.893 315.88 143.754C315.322 143.156 314.111 141.782 313.728 141.065C313.25 140.168 312.653 136.941 312.294 135.328Z"
          fill="#DFD1B6"
        />
        <path
          d="M330.996 154.02L266.402 158.872L244.65 177.038L310.383 173.453L330.996 154.02Z"
          fill="#9EA8BD"
          stroke="#9EA8BD"
          strokeWidth="1.91222"
        />
        <path
          d="M268.242 162.218C261.358 160.689 256.45 162.856 254.856 164.131C247.207 167.955 247.207 174.648 250.076 173.692C252.944 172.736 263.461 172.736 266.329 170.823C269.198 168.911 276.847 164.131 268.242 162.218Z"
          fill="#DFD1B6"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2151_1763"
          x1="149.334"
          y1="87.9628"
          x2="149.334"
          y2="308.446"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6FB5BA" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2151_1763"
          x1="279.129"
          y1="176.224"
          x2="279.129"
          y2="294.457"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#051C33" />
          <stop offset="1" stopColor="#3A5C7E" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2151_1763"
          x1="121.925"
          y1="121.792"
          x2="121.925"
          y2="341.571"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#051C33" />
          <stop offset="1" stopColor="#3A5C7E" />
        </linearGradient>
      </defs>
    </svg>
  )
}
